import * as yup from "yup";
import { emailMustBeValidEmail } from "../../../../common/infrastructure/helpers/yupHelper";

export const forgottenPasswordFormSchema = yup
  .object({
    email: yup
      .string()
      .email(emailMustBeValidEmail())
      .required("Полето 'Имейл' е задължително")
      .trim()
      .max(200)
      .defined(),
  })
  .required();

export type IForgottenPasswordFormModel = yup.InferType<
  typeof forgottenPasswordFormSchema
>;

export const forgottenPasswordFormDefaultValues: IForgottenPasswordFormModel = {
  email: "",
};
